/* eslint-disable no-continue */
/* eslint-disable no-restricted-globals */
import { Button, IconButton, Stack } from '@mui/material';
import React, { useEffect, useState } from 'react';
import AddOutlinedIcon from '@mui/icons-material/AddOutlined';
import RemoveOutlinedIcon from '@mui/icons-material/RemoveOutlined';
import { IProduct } from 'types/productType';
import { BASEURL } from 'context/context';

export type IAddProductButtonProps = {
  product: IProduct;
  callback?: () => void;
}

const AddProductButton: React.FC<IAddProductButtonProps> = ({ product, callback }) => {
  const [productQuantityInCart, setProductQuantityInCart] = useState(0);

  const updateToDatabase = async (addItemToCart: boolean) => {
    const userId = localStorage.getItem('userId');

    const myHeaders = new Headers();
    myHeaders.append('Content-Type', 'application/json');

    const raw = JSON.stringify({
      productId: parseInt(product.uid, 10),
      userId,
    });

    const requestOptions = {
      method: 'POST',
      headers: myHeaders,
      body: raw,
      redirect: 'follow',
    };

    try {
      const result = await fetch(`${BASEURL}/${
        addItemToCart
          ? 'addProductToCart'
          : 'removeProductFromCart'
      }`, requestOptions as any);

      console.log(await result.text());
      return result;
    } catch (e) {
      console.error(e);

      throw e;
    }
  };

  const addItemToCart = () => {
    const cart = localStorage.getItem('cart');
    if (cart == null || cart === '') {
      localStorage.setItem('cart', `${product.uid};`);
    } else {
      localStorage.setItem('cart', `${cart}${product.uid};`);
    }

    updateToDatabase(true).then(() => {
      setProductQuantityInCart(productQuantityInCart + 1);
    });
    callback?.();
  };

  const removeItemFromCart = () => {
    const cart = localStorage.getItem('cart');
    if (cart == null) {
      return;
    }
    const cartItems = cart.split(';');

    let index = -1;
    let cartString = '';

    for (let i = 0; i < cartItems.length; i++) {
      if (index === -1 && cartItems[i].includes(product.uid)) {
        index = i;
        continue;
      }
      if (!isNaN(parseInt(cartItems[i], 10))) {
        cartString += `${cartItems[i]};`;
      }
    }

    localStorage.setItem('cart', cartString);
    updateToDatabase(false).then(() => {
      setProductQuantityInCart(productQuantityInCart - 1);
    });
    callback?.();
  };

  useEffect(() => {
    const cart = localStorage.getItem('cart');
    let counter = 0;

    if (cart != null) {
      cart.split(';').forEach((item) => {
        if (item.includes(product.uid)) {
          counter++;
        }
      });
    }

    setProductQuantityInCart(counter);
  }, []);

  return (
    <div style={{
      marginRight: '10px',
      marginBottom: '5px',
    }}
    >
      {
            productQuantityInCart === 0
              ? (
                <Button
                  disabled={
                    product.quantity <= 0
                    || (product.quantity - productQuantityInCart) <= 0
                  }
                  onClick={addItemToCart}
                >
                  Add
                </Button>
              )
              : (
                <Stack direction="row">
                  <IconButton
                    size="small"
                    sx={{
                      height: '25px',
                      width: '25px',
                    }}
                    disabled={
                      product.quantity <= 0
                    || (product.quantity - productQuantityInCart) <= 0
                    }
                    onClick={addItemToCart}
                  >
                    <AddOutlinedIcon />
                  </IconButton>
                  <div style={{
                    marginLeft: '8px',
                    marginRight: '8px',
                  }}
                  >
                    {productQuantityInCart}

                  </div>
                  <IconButton
                    size="small"
                    sx={{
                      height: '20px',
                      width: '20px',
                    }}
                    onClick={removeItemFromCart}
                  >
                    <RemoveOutlinedIcon />
                  </IconButton>
                </Stack>
              )
        }

    </div>
  );
};

export { AddProductButton };
